"use client";
// import FlickityShow from "../../../utils/Flickity/Flickity";
import { useState, useEffect } from "react";
const Highlighted = ({ data }) => {
  const [dataFeatuers, setDataFeatuers] = useState([]);
  useEffect(() => {
    // data.data?.map((res) => {
    // if (res.name === "dataFeatures")
    setDataFeatuers(data.featuredPosts);
    // if (res.name === "dataCategories")
    // setDataFeatuers(data.data.featuredPosts);
    // if (res.name === "dataEventsToday")
    // setDataEvents(dashboardData.eventsToday);
    // });
  }, []);

  // return <FlickityShow data={data} />;
};

export default Highlighted;
